import { Enum } from "../../../enums/enum.class";
import EnumItem from "../../../enums/enumItem.class";

class TipoInputEnum extends Enum{
    constructor() {
        super();
        this.INVALID = new TipoDeInputEnumItem(0, 'INVALID', null, null, null, null);
        this.TEXT = new TipoDeInputEnumItem(1, 'TEXT', 'Parágrafo', 'mdi-text', 'TrfCampoParagrafo', 'TrfInputParagrafo');
        this.RADIO = new TipoDeInputEnumItem(2, 'RADIO', 'Múltipla escolha', 'mdi-radiobox-marked', 'TrfCampoMultiplaEscolha', 'TrfPreenchimentoMultiplaEscolha');
        this.CHECKBOX = new TipoDeInputEnumItem(3, 'CHECKBOX', 'Caixas de seleção', 'mdi-checkbox-outline', 'TrfCaixaDeSelecao', 'TrfPreenchimentoCaixaDeSelecao');
        this.SELECT = new TipoDeInputEnumItem(4, 'SELECT', 'Lista suspensa', 'mdi-chevron-down-circle-outline', 'TrfListaSuspensa', 'TrfPreenchimentoListaSuspensa');
    }
}
class TipoInputPadraoEnum extends Enum{
    constructor() {
        super();
        this.INVALID = new TipoDeInputEnumItem(0, 'INVALID', null, null, "div", "div");
        this.NOME_FANTASIA = new TipoDeInputEnumItem(1, 'NOME_FANTASIA', 'Nome fantasia', null, "TrfBlocoNomeFantasia", "TrfBlocoNomeFantasia");
        this.SUGESTOES_NOME_EMPRESARIAL = new TipoDeInputEnumItem(2, 'SUGESTOES_NOME_EMPRESARIAL', 'Sugestões de nome empresarial', null, "TrfBlocoNomeEmpresarial", "TrfBlocoNomeEmpresarial");
        this.ENDERECO_EMPRESA = new TipoDeInputEnumItem(3, 'ENDERECO_EMPRESA', 'Endereço da empresa', null, "TrfBlocoEnderecoEmpresarial", "TrfBlocoEnderecoEmpresarial");
        this.DADOS_COMPLEMENTARES = new TipoDeInputEnumItem(4, 'DADOS_COMPLEMENTARES', 'Dados complementares', null, "TrfBlocoDadosComplementares", "TrfBlocoDadosComplementares");
        this.ADICIONAR_SOCIO = new TipoDeInputEnumItem(5, 'ADICIONAR_SOCIO', 'Sócios', null, "TrfBlocoSocios", "TrfBlocoSocios");
        this.DADOS_SOCIO = new TipoDeInputEnumItem(6, 'DADOS_SOCIO', 'Dados do sócio', null, "TrfBlocoSocioDados", "TrfBlocoSocioDados");
        this.DADOS_COMPLEMENTARES_SOCIO = new TipoDeInputEnumItem(7, 'DADOS_COMPLEMENTARES_SOCIO', 'Dados complementares do sócio', null, 'TrfBlocoSocioDadosComplementares', 'TrfBlocoSocioDadosComplementares');
        this.TIPO_SOCIO = new TipoDeInputEnumItem(8, 'TIPO_SOCIO', 'Tipo de sócio', null, 'TrfBlocoSocioTipo', 'TrfBlocoSocioTipo');
        this.ENDERECO_SOCIO = new TipoDeInputEnumItem(9, 'ENDERECO_SOCIO', 'Endereço do sócio', null, "TrfBlocoEnderecoSocio", "TrfBlocoEnderecoSocio");
        this.INFORMACOES_CONTATO = new TipoDeInputEnumItem(10, 'INFORMACOES_CONTATO', 'Informações de contato do sócio', null, "TrfBlocoSocioContato", "TrfBlocoSocioContato");
        this.ANEXOS = new TipoDeInputEnumItem(11, 'ANEXOS', 'Anexos', null, "TrfBlocoAnexos", "TrfBlocoAnexos");
        this.IPTU_EMPRESA = new TipoDeInputEnumItem(12, 'IPTU_EMPRESA', 'Qual o número do IPTU da empresa?', null, "TrfBlocoIptuEmpresarial", "TrfBlocoIptuEmpresarial");
    }
}

class TipoDeInputEnumItem extends EnumItem {
    constructor(id, key, nome, icone, componenteEdicao, componentePreenchimento) {
        super(id, key);
        this.nome = nome
        this.icone = icone
        this.componenteEdicao = componenteEdicao
        this.componentePreenchimento = componentePreenchimento
    }

    getNome() {
        return this.nome
    }

    getIcone() {
        return this.icone
    }

    getComponenteEdicao() {
        return this.componenteEdicao
    }

    getComponentePreenchimento() {
        return this.componentePreenchimento
    }
}

export const tipoInputEnum = new TipoInputEnum();
export const tipoInputPadraoEnum = new TipoInputPadraoEnum();